import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useCourses } from '../courses/Courses';
import { useGrades } from '../grades/Grades';
import { useInstitutions } from '../institutions/Institutions';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/students/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setEntries({
          ...data?.data,
          ...data?.data?.details,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }, [id]);

  function handleChange(e) {
    let { name, value } = e.target;
    if (value.includes('{') && value.includes('}')) {
      value = JSON.parse(value);
    }
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
  };
}

export function UpdateStudent() {
  const classes = useStyles();
  const { handleChange, entries } = useForm();
  const { grades } = useGrades();
  const { courses } = useCourses();
  const { institutions } = useInstitutions();
  const navigate = useNavigate();

  const handleUpdate = async () => {
    try {
      const { _id, ...data } = entries;
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/students/${_id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );
      let result = await response.json();
      if (result.success === true) {
        navigate('/admin/students', { replace: true });
      } else {
        console.error(result.message);
        window.alert('Error al actualizar el estudiante, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar el estudiante, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="institution-label">Institución</InputLabel>
        <Select
          labelId="institution-label"
          id="institution"
          name="institution"
          value={entries?.institution?._id || ''}
          onChange={handleChange}
          label="Institución"
          native
        >
          {institutions.map((institution) => (
            <option value={institution?._id}>{institution?.name}</option>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="grade-label">Grado</InputLabel>
        <Select
          labelId="grade-label"
          id="grade"
          name="grade"
          value={entries?.grade?._id || ''}
          onChange={handleChange}
          label="Grado"
          native
        >
          {grades.map((grade) => (
            <option value={grade?._id}>{grade?.name}</option>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="course-label">Curso</InputLabel>
        <Select
          labelId="course-label"
          id="course"
          name="course"
          value={entries?.course?._id || ''}
          onChange={handleChange}
          label="Curso"
          native
        >
          {courses.map((course) => (
            <option
              value={course?._id}
            >{`${course?.numericName} (${course?.alphaName})`}</option>
          ))}
        </Select>
      </FormControl>
      <TextField
        className={classes.input}
        label="Correo electrónico"
        variant="outlined"
        name="email"
        onChange={handleChange}
        value={entries?.email || ''}
        type={'email'}
      />
      <TextField
        className={classes.input}
        label="Contraseña"
        variant="outlined"
        name="password"
        onChange={handleChange}
        value={entries?.password || ''}
        type={'password'}
      />
      <TextField
        className={classes.input}
        label="Nombre"
        variant="outlined"
        name="name"
        onChange={handleChange}
        value={entries?.name || ''}
      />
      <TextField
        className={classes.input}
        label="Apellido"
        variant="outlined"
        name="lastName"
        onChange={handleChange}
        value={entries?.lastName || ''}
      />

      <Button
        onClick={handleUpdate}
        className={classes.input}
        variant="contained"
        color="primary"
        disabled={
          !entries?.name ||
          !entries?.lastName ||
          !entries?.grade ||
          !entries?.course ||
          !entries?.institution
        }
      >
        Actualizar
      </Button>
    </div>
  );
}
